module.exports = __webpack_public_path__ + "img/logo.0c2d37ac.png";